__turbopack_context__.v({
  "paragraph-content": "HrVk_G_paragraph-content",
  "wrap-container": "HrVk_G_wrap-container",
  "wrap-content": "HrVk_G_wrap-content",
});
